import MuiSelect, { SelectVariants } from '@mui/material/Select';
import { SelectProps } from '../input.interface';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { styled } from '@mui/material/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { typographyBase } from '../../../../theme/typography';
import { useId } from 'react';

export const SelectInput = styled(MuiSelect, {
  name: 'Select',
  slot: 'input',
  overridesResolver: (_props, styles) => styles.input,
})({});

export const Select: React.FC<SelectProps & { variant?: SelectVariants }> = ({
  label,
  fullWidth,
  onChange,
  value,
  children,
  className,
  variant = 'outlined',
  ...props
}) => {
  const inputId = useId();

  return (
    <InputWrapper label={label} fullWidth={fullWidth} className={className} labelId={inputId}>
      <SelectInput
        variant={variant}
        value={value}
        onChange={onChange}
        IconComponent={variant === 'filled' ? KeyboardArrowDownIcon : undefined}
        labelId={inputId}
        {...props}
        sx={{ ...props.sx, '&::before': { visibility: 'hidden' } }}
        MenuProps={{
          sx: {
            '& li': {
              ...typographyBase.text1,
              paddingLeft: 12,
              paddingRight: 12,
            },
          },
        }}
      >
        {children}
      </SelectInput>
    </InputWrapper>
  );
};
